__webpack_require__.p = "https://infopoint-energy.tools.planval.ch/build/";